import styled from 'styled-components';

import { SIZES } from '../Base/Base.constants';
import { Base } from '../Base/Base';

export const ContentBlock = styled(Base).attrs({ size: SIZES.S })``;
